import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessingPrePostReview extends Layout {
    labelInvoiceCount: Label;
    labelInvoiceCountCaption: Label;
    labelPrePostReview: Label;
    labelTotalInvoicedAmount: Label;
    labelTotalInvoicedAmountCaption: Label;
    panelMulticurrencyTotals: Panel;
    panelPrePostReview: Panel;
    panelReportPreview: Panel;
    sourceConfirmMiscInvoicePrint: DataSource;
}
